import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

const PermalinkGenerator = () => {
  const [title, setTitle] = useState("");
  const [permalink, setPermalink] = useState("");
  const [existingPermalinks, setExistingPermalinks] = useState([]); // To track existing slugs

  const generateSlug = (inputTitle) => {
    const baseSlug = inputTitle
      .trim()
      .toLowerCase()
      .replace(/[0-9+]/g, "") // Remove numbers and the '+' sign
      .replace(/\s+/g, "-") // Replace spaces with hyphens
      .replace(/[^\w-]+/g, "") // Remove all non-alphanumeric characters except hyphens
      .replace(/^-+|-+$/g, ""); // Remove leading or trailing hyphens

    let uniqueSlug = baseSlug;
    let counter = 1;

    // Ensure uniqueness
    while (existingPermalinks.includes(uniqueSlug)) {
      uniqueSlug = `${baseSlug}-${counter}`;
      counter++;
    }

    return uniqueSlug;
  };

  const handleTitleChange = (e) => {
    const inputTitle = e.target.value;
    setTitle(inputTitle);
    const uniqueSlug = generateSlug(inputTitle);
    setPermalink(uniqueSlug);
  };

  const handleCopy = () => {
    if (permalink) {
      setExistingPermalinks((prev) => [...prev, permalink]); // Save the slug
      navigator.clipboard.writeText(permalink);
      toast.success("Permalink copied to clipboard!", {
        position: "top-center",
      });
    } else {
      toast.error("Please enter a title first.", {
        position: "top-center",
      });
    }
  };

  return (
    <div className="container mt-5">
      <div className="card p-4">
        <div className="form-group mb-3">
          <label htmlFor="title" className="form-label">
            Enter Title:
          </label>
          <input
            type="text"
            id="title"
            value={title}
            onChange={handleTitleChange}
            placeholder="Enter your title here"
            className="form-control"
          />
        </div>

        <div className="form-group mb-3">
          <label htmlFor="permalink" className="form-label">
            Permalink:
          </label>
          <input
            type="text"
            id="permalink"
            value={permalink}
            readOnly
            className="form-control"
          />
        </div>

        <button onClick={handleCopy} className="btn btn-primary w-100">
          Copy Now
        </button>
      </div>

      <ToastContainer />
    </div>
  );
};

export default PermalinkGenerator;
